import { Title } from '@panwds/react-ui'
import { useMemo } from 'react'
import { APP_ID_PAN_CHINA } from '../../../common/constants/GlobalConstants'
import { CHINA_HEADER } from '../../../common/constants/LabelConstants'
import LicenseAddon from './LicenseAddon'
import LicenseLineItem from './LicenseLineItem'
import { ARRAY } from '../../../common/utils/Utils'
import AppImage from '../../../common/components/appName/AppImage'

/*
 * Created By sswaminathan
 * Created on Mon Nov 22 2021
 * Created on LicenseCardHeader.js
 * Copyright (c) 2021  ©Palo Alto Networks
 */

const LicenseCardHeader = ({
  label,
  quantity,
  location,
  expiry,
  imageName,
  addons,
  showImage,
  hideTitle,
  license,
  ions: _ions,
  note,
  isPanChina = false
}) => {
  const ions = useMemo(() => {
    if (_ions && ARRAY.hasArray(Object.keys(_ions))) {
      return Object.entries(_ions).map(([ionName, purchaseSize], index) => (
        <LicenseLineItem key={index} label={ionName} value={purchaseSize} />
      ))
    }
  }, [_ions])

  const header = useMemo(() => {
    if (!isPanChina && !license?.entitlements?.length) {
      return ''
    }
    return isPanChina || license?.entitlements.some(({ app_id }) => app_id === APP_ID_PAN_CHINA) ? CHINA_HEADER : ''
  }, [isPanChina, license?.entitlements])

  return <div className="tw-flex tw-flex-row">
    {showImage && (
      <div>
        <AppImage style={{ width: '36px', height: '48px' }} app_id={imageName} alt="Prisma Access"/>
      </div>
    )}
    <div className='tw-flex tw-flex-col tw-ml-2 tw-flex-grow'>
      {!hideTitle && <Title size='sm' level={2}>{`${label} ${header}`}</Title>}
      {ions}
      {quantity && <LicenseLineItem label="License quantity:" value={quantity}/>}
      {location && <LicenseLineItem label="Service location:" value={location}/>}
      {ARRAY.hasArray(addons) && <LicenseAddon addons={addons}/>}
      {expiry && <LicenseLineItem label='Expires:' value={expiry}/>}
      {note && <LicenseLineItem labelColor='green' label={'Note: '} value={note} />}
    </div>
  </div>
}

LicenseCardHeader.defaultProps = {
  showImage: true
}
export default LicenseCardHeader
